<!-- Enforce Blocked Caller Command -->
<app-vrc-list-editor
  *ngIf="!loading"
  [(objList)]="commandsToExecuteOnEnforce"
  (objListChange)="updateObjAndEmit()"
></app-vrc-list-editor>

<!-- Is Valid Indicator -->
<app-obj-is-valid *ngIf="!loading" [isValidObj]="isValidObjScoper"></app-obj-is-valid>
